import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';
import { documentDetailApiService, documentPOApiService } from 'src/services';

export const useDocClassificationStore = defineStore('classification', {
  state: () => ({
    restart_classification_popup: false,
    label_classification_popup: false,
    confirmation: false,
    trigger_classification: false,
    reset_classification: false,
    display_pages_dropdown: false,
    selected_page: null,
    selected_custom_model_label: '',
  }),

  actions: {
    resetStore() {
      this.$reset();
    },
  },
});
